var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV6LogoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.75H15.625V15.625V16.7578L19.8438 12.5L15.625 8.28125V9.375V11.25H13.75H10.625V13.75H13.75ZM21.1719 13.8281L16.25 18.75H15.625H13.75V17.5V16.875V15.625H11.875H10.625H8.75V13.75V11.25V9.375H10.625H11.875H13.75V8.125V7.5V6.25H15.625H16.25L21.1719 11.2109L22.5 12.5L21.1719 13.8281ZM9.0625 5.625H4.375V19.375H9.0625H10V21.25H9.0625H3.4375H2.5V20.3125V4.6875V3.75H3.4375H9.0625H10V5.625H9.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV6LogoutIcon);
export default __webpack_public_path__ + "static/media/v6-logout-icon.985501063e352b617ccbb91f33e62dc5.svg";
export { ForwardRef as ReactComponent };